export default class AdminPatientReports {
  axiosIns = null
  jwtConfig = null

  constructor(axiosIns, jwtConfig) {
    this.axiosIns = axiosIns;
    this.jwtConfig = jwtConfig;
  }

  fetchNumberOfConsultationsForPatient(params) {
    return this.axiosIns.get(`${this.jwtConfig.main.adminReportsRoute}/patient/consultations`, {
      params
    })
  }

  fetchLabsForPatient(params) {
    return this.axiosIns.get(`${this.jwtConfig.main.adminReportsRoute}/patient/labs`, {
      params
    })
  }
  
  fetchMedicationsForPatient(params) {
    return this.axiosIns.get(`${this.jwtConfig.main.adminReportsRoute}/patient/medications`, {
      params
    })
  }
  
  exportLabs(params) {
    return this.axiosIns.get(`${this.jwtConfig.main.adminReportsRoute}/patient/export/labs`, {
      params,
      responseType: "blob"
    })
  }

  exportMedications(params) {
    return this.axiosIns.get(`${this.jwtConfig.main.adminReportsRoute}/patient/export/medications`, {
      params,
      responseType: "blob"
    })
  }
}
